import React from 'react';
import { Button, Card, Text } from '@fragments';
import { IconArrowRight, IconClockHour4, IconCoins } from '@tabler/icons-react';
import { formatCredits } from '../../../../data/payments';
import './styles.scss';

// `GET /studio/usage`: what can be spent now, split into the plan's allowance (spent first,
// expiring at renewal) and credits that never expire (packs, the initial grant); credits held
// by operations still running; and the way to buy more.
export default function BalanceCard({ studio: s }) {
  const { t } = s;
  const p = s.payments;
  const locale = s.locale.replace('_', '-');
  const count = units => formatCredits(units, locale);
  const usage = s.snapshot.usage || {};
  const available = usage.available_units ?? 0;
  const allowance = usage.allowance_units ?? 0;
  const purchased = usage.purchased_units ?? Math.max(available - allowance, 0);
  const reserved = usage.reserved_units ?? 0;
  const paid = p.plan !== 'free';
  return <Card split className="studio-plan-balance">
    <div className="studio-plan-balance__head">
      <Text.subheading contrast={6} left={<IconCoins />}>{t('billingBalanceEyebrow')}</Text.subheading>
      {p.pack && <Button variant="rounded" color="inverse" size="small" endIcon={<IconArrowRight />} preventLoading onClick={() => p.openCredits()}>{t('upgradeCardBuy')}</Button>}
    </div>
    <div className="studio-plan-balance__value">
      <Text.h2 contrast={10} weight={500}>{count(available)}</Text.h2>
      <Text.caption contrast={6}>{t('upgradeCardBalance')}</Text.caption>
    </div>
    <div className="studio-plan-balance__split" aria-hidden="true">
      {paid && <i className="is-plan" style={{ flexGrow: allowance }} />}
      <i className="is-pack" style={{ flexGrow: purchased }} />
    </div>
    <ul className="studio-plan-balance__legend">
      {paid && <li><i className="is-plan" aria-hidden="true" /><Text.caption contrast={7}>{t('creditsPlanShare', { plan: t(`planName_${p.plan}`) })}</Text.caption><Text.caption contrast={9}>{count(allowance)}</Text.caption></li>}
      <li><i className="is-pack" aria-hidden="true" /><Text.caption contrast={7}>{t('creditsPackShare')}</Text.caption><Text.caption contrast={9}>{count(purchased)}</Text.caption></li>
    </ul>
    {reserved > 0 && <Text.caption contrast={6} left={<IconClockHour4 />}>{t('billingReserved', { credits: count(reserved) })}</Text.caption>}
  </Card>;
}
